import styled, { css } from 'styled-components'

import { backgroundTransparentDefault } from 'common-constants/colors'
import { photoButtonCss } from 'components/page/PhotoViewer/Panel/Panel.styled'
import { defaultButtonProps } from 'components/presentational/button/button.constants'
import { DarkLightStyled } from 'components/presentational/theme/DarkLight'

const containerCss = css`
  ${photoButtonCss}
  padding: 0 10px;
  position: relative;
  z-index: 1;
`

export const PhotoButton = styled.div<DarkLightStyled>`
  ${containerCss}
  cursor: pointer;
  display: flex;
  flex-direction: row;
`

export const PhotoContainer = styled.div<DarkLightStyled>`
  ${containerCss}
  ${(props) =>
    props.$dark
      ? `
      &:hover,
      &:active{
        background-color: ${backgroundTransparentDefault};
      }          
    `
      : ''};
`

PhotoButton.defaultProps = defaultButtonProps
